import React, { useState } from "react";
import useDocumentTitle from "../../assets/utils/useDocumentTitle";
import {
  Breadcrumb,
  Footer,
  Header,
  Numbering,
  PanelAccordion,
  Sidebar,
} from "../../components";
import "./style.scss";
import { items } from "./ListContentAccordion";

function JPpbb() {
  useDocumentTitle("Pelayanan PBB - BAPENDA BEKASI");
  const [isActive, setIsActive] = useState(null);

  return (
    <div className="page">
      <Header active="JPpbb" />

      {/* main */}
      <main className="main-sb">
        <section className="content">
          <Breadcrumb path="Jenis Pajak / PBB" />
          <div className="page-title-wrapper">
            <div className="page-title">Pajak PBB</div>
          </div>
          <div className="jenis-pajak-title">
            <strong>Pajak Bumi Dan Bangunan Perdesaan Dan Perkotaan</strong>
          </div>
          <div className="jenis-pajak-content">
            <p className="page-text">
            
            Pajak Bumi dan Bangunan Perdesaan dan Perkotaan yang selanjutnya
disingkat PBB-P2 adalah Pajak atas bumi dan/atau bangunan yang
dimiliki, dikuasai, dan/ atau dimanfaatkan oleh orang pribadi atau Badan. Objek PBB-P2 adalah Bumi dan/atau Bangunan yang dimiliki, dikuasai
dan/atau dimanfaatkan oleh orang pribadi atau Badan, kecuali kawasan
yang digunakan untuk kegiatan usaha perkebunan, perhutanan, dan
pertambangan.<br></br>
Subjek PBB-P2 adalah orang pribadi atau Badan yang secara nyata
mempunyai suatu hak atas Bumi dan/atau memperoleh manfaat atas Bumi,
dan/atau memiliki, menguasai, dan/atau memperoleh manfaat atas
Bangunan<br></br>
Wajib PBB-P2 adalah orang pribadi atau Badan yang secara nyata mempunyai
suatu hak atas Bumi dan/atau memperoleh manfaat atas Bumi, dan/atau
memiliki, menguasai, dan/atau memperoleh manfaat atas Bangunan.
			</p>
      <p className="page-text">
DASAR HUKUM : <br></br>
<a href="https://jdih.bekasikota.go.id/peraturan-daerah/view?id=525" target="_blank" rel="noreferrer"><font color="blue">Peraturan Daerah Kota Bekasi Nomor 1 Tahun 2024 Tentang Pajak Daerah Dan Retribusi Daerah</font></a>
</p>
 <div className="jenis-pajak-title">
           <p><b>Jenis Pelayanan & Persyaratan</b></p>
		   </div>
          </div>
          <div className="jenis-pajak-content">
            {items.map((item, index) => {
              return (
                <PanelAccordion
                  key={index}
                  label={item.label}
                  content={item.content}
                  index={index}
                  setIsActive={setIsActive}
                  isActive={isActive}
                />
              );
            })}
          </div>
        </section>
        <Sidebar />
      </main>

      <Footer />
    </div>
  );
}

export default JPpbb;
